import { apiClient } from './client';
import type { MantenimientoItem } from '@/types/dominio';

export interface ListaMantenimientoParams {
  semaforo?: 'OK' | 'WARN' | 'DANGER' | 'SIN_PROGRAMAR';
  busqueda?: string;
  page?: number;
  pageSize?: number;
}

export interface ListaMantenimientoResp {
  items: MantenimientoItem[];
  total: number;
  page: number;
  pageSize: number;
}

export async function getMantenimientos(params: ListaMantenimientoParams = {}): Promise<ListaMantenimientoResp> {
  const { data } = await apiClient.get<ListaMantenimientoResp>('/mantenimiento', { params });
  return data;
}

export interface EjecutarMantenimientoPayload {
  tipo: 'MANTENIMIENTO_PREVENTIVO' | 'MANTENIMIENTO_CORRECTIVO';
  observaciones?: string;
  periodicidad_dias?: number; // permite ajustar la periodicidad al ejecutar
  pdf: File; // archivo PDF obligatorio
}

export async function ejecutarMantenimiento(
  idItem: string,
  payload: EjecutarMantenimientoPayload,
): Promise<MantenimientoItem> {
  const formData = new FormData();
  formData.append('tipo', payload.tipo);
  if (payload.observaciones) {
    formData.append('observaciones', payload.observaciones);
  }
  if (payload.periodicidad_dias) {
    formData.append('periodicidad_dias', payload.periodicidad_dias.toString());
  }
  formData.append('pdf', payload.pdf);

  const { data } = await apiClient.post<MantenimientoItem>(
    `/mantenimiento/${idItem}/ejecutar`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}
